<div *ngIf="sanitizedContent" class="videoWrapper mt-1 w-100">
	<div class="ql-container ql-snow" style="border-width: 0;">
		<div class="ql-editor" [innerHTML]="sanitizedContent"></div>
	</div>
</div>
<video #videoPlayer autoplay [muted]="true"></video>
